import React, { useState } from 'react';
import { Box, Typography, Paper, Fade } from '@mui/material';
import AuthButton from './AuthButton';
import { iconEmail, iconGoogle, iconMicrosoft, iconMyLogin, iconSmiley } from '../assets/images';


export default function UnifiedLoginOptions({ onLoginMethodChange }) {
  const [loading, setLoading] = useState({});

  const handleLoginMethodClick = (method) => {
    setLoading(prev => ({ ...prev, [method]: true }));
    
    setTimeout(() => {
      onLoginMethodChange(method);
      
      setTimeout(() => {
        setLoading(prev => ({ ...prev, [method]: false }));
      }, 300);
    }, 150);
  };

  const renderLoginOptions = () => (
    <Fade 
      in={true}
      timeout={{ 
        enter: 500,
        exit: 300
      }}
      style={{ 
        transitionDelay: '150ms'
      }}
    >
      <div className="login-btns">       
        
        {/* Email Login */}
        <AuthButton
          provider="email"
          icon={<img src={iconEmail} alt="" />}
          label="Login With Email"
          bgcolor="#E84F6B"
          hovercolor="#E84F6B"
          onClick={() => handleLoginMethodClick('email')}
          loading={!!loading.email}
        />

        {/* Emoji Login */}
        <AuthButton
          provider="emoji"
          icon={<img src={iconSmiley} alt="" />}
          label="Login With Emoji"
          bgcolor="#EB5B41"
          hovercolor="#EB5B41"
          onClick={() => handleLoginMethodClick('emoji')}
          loading={!!loading.emoji}
        />

        {/* Google Login */}
        <AuthButton
          provider="google"
          icon={<img src={iconGoogle} alt="" />}
          label="Login With Google"
          bgcolor="#53B5E0"
          hovercolor="#53B5E0"
          onClick={() => handleLoginMethodClick('google')}
          loading={!!loading.google}
        />

        {/* Microsoft Login */}
        <AuthButton
          provider="microsoft"
          icon={<img src={iconMicrosoft} alt="" />}
          label="Login With Microsoft"
          bgcolor="#45338C"
          hovercolor="#45338C"
          onClick={() => handleLoginMethodClick('microsoft')}
          loading={!!loading.microsoft}
        />

        {/* MyLogin */}
        <AuthButton
          provider="mylogin"
          icon={<img src={iconMyLogin} alt="" />}
          label="Login With MyLogin"
          bgcolor="#007A7A"
          hovercolor="#007A7A"
          onClick={() => handleLoginMethodClick('mylogin')}
          loading={!!loading.mylogin}
        />
      </div>
    </Fade>
  );

  return (
    <>
      {renderLoginOptions()}
    </>
  );
}
